export const llgContractAddress = "0x0e04Ad5f9a40ddfe82ac533C9D5284Fb3C72BcAa";//"0x4691F60c894d3f16047824004420542E4674E621";
export const llgRewardContractAddress = "0x2ee17E424bEB5273a4016732A87D320Dff5E8827";//"0xa5A76dE54c29B4A29229d8f4ae82338325430dcA";
// export const chainId = 0x61;
export const chainId = 0x1;